/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';

  /**
   * Вид для блока с количеством и кнопкой "в корзине" для товара в корзине
   */
  app.CartItemQtyView = app.ItemQtyView.extend({
    isCart: true,
    additionalOptions: [
      'itemView',
      'item',
      'isMobile',
    ],
    run: function () {
      this.access = {
        canRemoveFromCart: true
      };
      this.template = app.helpers.TemplateHelper.getTemplate('#cart-price-template');
      this.input = this.$('[data-cart-input]');
      this.value = this.model.get('qty');
      this.price = this.item.get('price');
      this.minimum = this.item.get('minQty');
      this.maximum = this._initMaximum();
      // при очистке корзины
      this.listenTo(this.cart, 'clear', this.remove);
      // при добавлении товаров в корзину ищем себя там
      this.addCartItemToCart();
    },

    /**
     * Загружает подарки
     */
    getGifts: function () {
      if (app.gifts.length) {
        app.gifts.getGifts();
      }
    },
    render: function (options) {
      var qty = this.model.get('qty'),
        price = this.model.get('price'),
        priceOld = this.model.get('price_max'),
        hasCustomUnits = this.item.get('has_custom_qty_units'),
        hasDiscount = this.item.get('has_discount'),
        hasMarkup = this.item.get('real_min_qty') > qty,
        qtyIsWeight = this.item.get('is_weighted_goods'),
        nestedUnitName;
      if (hasCustomUnits) {
        if (qty) {
          qty = this.convertQtyBasedOnNestedUnit(qty, this.item.get('in_set'), 'to');
        }
        var inSet = this.item.get('in_set');
        price = price / inSet;
        priceOld = priceOld / inSet;

        var nestedUnit = this.item.get('nestedUnit');
        nestedUnitName = _.isObject(nestedUnit) && nestedUnit.name;
      }
      if (qtyIsWeight) {
        price = price * 10;
        priceOld = priceOld * 10;
        hasCustomUnits = true;
        nestedUnitName = 'кг';
      }
      var transitSettlements = this.model.get('item') && this.model.get('item').transit_in_settlement;
      var settlementId = this.settlement && this.settlement.get('settlement_id');
      this.$el.html(this.template({
        visibleQty: this.getVisibleValue(qty),
        qty: qty,
        price: app.helpers.NumberHelper.numberWithoutZeroFraction(price),
        priceOld: app.helpers.NumberHelper.numberWithoutZeroFraction(priceOld),
        cartItem: this.model.toJSON(),
        item: this.item.toJSON(),
        qtyRule: hasMarkup && !this.isMobile ? '' : this.getQtyRule(),
        hasCustomUnits: hasCustomUnits,
        hasDiscount: hasDiscount,
        nestedUnit: this.item.get('nestedUnit'),
        nestedUnitName: nestedUnitName,
        isAvailableInSettlement: this.item.get('is_available_in_settlement', true),
        showDisabledTransit: transitSettlements
          && transitSettlements.length
          && transitSettlements.indexOf(settlementId) === -1,
      }));
      this.initDom();
      this.updateControls.apply(this, options.controls);
      this.renderRetailFeeMarkup();
    },
  });
})();

}.call(window));